<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        <p class="fs-6 m-2">
          {{ this.$route.meta.title }}
        </p>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
        <form class="row">
          <div class="col-md-6 col-xs-12">
            <div class="form-floating mb-3">
              <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                placeholder="نام دسته"
                v-model="formData.name"
              />
              <label for="name">نام *</label>
            </div>

            <div class="form-floating mb-3">
              <select v-model="formData.published" class="form-control">
                <option value="1">منتشر شده</option>
                <option value="0">عدم انتشار</option>
              </select>
              <label>وضعیت *</label>
            </div>

            <input
              type="text"
              class="form-control"
              placeholder="ترتیب"
              v-model="formData.ordering"
            />
            <label for="name"> ترتیب</label>
          </div>
          <div class="col-md-4 col-xs-12">
            <div v-if="formData.id">
              <label for="image_path" class="form-label"> تصویر </label>
              <a :href="API_STORAGE_URL + formData.image_path" target="_blank">
                <img
                  v-if="formData.image_path"
                  :src="API_STORAGE_URL + formData.image_path"
                  class="img-thumbnail"
                />
              </a>
              <input
                class="form-control form-control-sm my-1"
                id="image_path"
                type="file"
                @change="addUploadFile($event)"
              />

              <div class="mt-2">
                <a class="btn btn-sm btn-success" @click="setImage()">
                  <i class="fas fa-plus"></i>
                  ذخیره تصویر
                </a>

                <span
                  v-show="showFileSpin"
                  class="fas fa-spinner fa-spin mt-3"
                ></span>

                <a
                  v-show="formData.image_path"
                  class="btn btn-sm btn-danger mx-1"
                  @click="deleteImage()"
                >
                  <i class="fas fa-trash"></i>
                  حذف تصویر
                </a>
              </div>
            </div>
            <span v-else> پس از ذخیره دسته، امکان درج تصویر فراهم است </span>
          </div>
        </form>
        <div>
          <a class="btn btn-primary btn-block" @click="addEditCategoryone()">
            ثبت
          </a>
          <span v-show="showSpin">
            <i class="fas fa-spinner fa-spin mt-3"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../components/TheSidemenu";
import TheTopmenu from "../components/TheTopmenu";
import ArefApi from "../libs/api.js";
import utils from "../libs/utils";

export default {
  name: "AddCategoryone",
  created() {
    this.arefApi = new ArefApi();
    this.utils = new utils();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
  },
  data() {
    return {
      error: null,
      showSpin: false,
      showFileSpin: false,
      formData: {
        id: this.$route.params.categoryoneId
          ? this.$route.params.categoryoneId
          : null,
        name: null,
        image_path: null,
        published: 1,
        ordering:1
      },
      API_STORAGE_URL: process.env.VUE_APP_API_STORAGE_URL,
    };
  },
  methods: {
    addEditCategoryone: async function () {
      if (!this.validateFrm()) {
        return;
      }
      this.showSpin = true;

      const fn = this.formData.id ? "editCategoryone" : "addCategoryone";

      this.arefApi[fn](this.formData)
        .then(() => {
          this.$swal
            .fire({
              title: "",
              text: `ثبت با موفقیت انجام شد`,
              icon: "success",
              confirmButtonText: "متوجه شدم",
            })
            .then(() => {
              if (!this.formData.id) {
                this.$router.push({ name: "ListCategoryones" });
              }
            });
        })
        .catch((err) => {
          let alertText = "";
          if (err.data.errors) {
            for (let i in err.data.errors) {
              alertText += (alertText ? "" : ",") + `${err.data.errors[i]} `;
            }
          }
          this.$swal.fire({
            title: "!خطا",
            text: `${alertText}`,
            icon: "error",
            confirmButtonText: "متوجه شدم",
          });
        })
        .finally(() => {
          this.showSpin = false;
        });
    },
    validateFrm: function () {
      this.error = null;
      if (!this.formData.name) {
        this.error = "نام باید بیشتر از دو حرف باشد";
        return false;
      }

      return true;
    },
    loadCategoryoneInfo: function () {
      return new Promise((resolve, reject) => {
        if (this.formData.id) {
          this.arefApi
            .getCategoryone(this.formData.id)
            .then((resp) => {
              this.formData = resp.data;
              resolve();
            })
            .catch((err) => {
              this.$swal
                .fire({
                  title: "خطا درنمایش اطلاعات !",
                  text: "دسته پیدا نشد ",
                  icon: "error",
                })
                .then(() => {
                  this.$router.push({ name: "EditCategoryone" });
                });
              reject(err);
            });
        }
      });
    },
    addUploadFile(event) {
      this.image_path = event.target.files[0];
    },
    setImage() {
      this.error = null;
      if (!this.image_path) {
        this.error = "فایل تصویر را انتخاب فرمایید";
        return;
      }

      this.showFileSpin = true;
      let formDataTmp = new FormData();
      formDataTmp.append("image_path", this.image_path);
      this.arefApi
        .setCategoryoneImage(formDataTmp, this.formData.id)
        .then(() => {
          this.$swal.fire({
            title: "",
            text: `ثبت تصویر با موفقیت انجام شد`,
            icon: "success",
            confirmButtonText: "متوجه شدم",
          });
          this.loadCategoryoneInfo();
          document.getElementById("image_path").value = "";
          this.image_path = null;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.showFileSpin = false;
        });
    },
    deleteImage() {
      this.arefApi
        .deleteCategoryoneImage(this.formData.id)
        .then(() => {
          this.$swal.fire({
            title: "",
            text: `حذف تصویر با موفقیت انجام شد`,
            icon: "success",
            confirmButtonText: "متوجه شدم",
          });
          this.loadCategoryoneInfo();
        })
        .catch((err) => {
          this.utils.showError(this, err);
        });
    },
  },
  mounted() {
    this.loadCategoryoneInfo();
  },
};
</script>

